import { AwaitContainer } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useBetaFeatures, useToggleBetaFeature } from '@/entities/beta-feature';
import { PageContainer } from '@/shared/ui';
import { BetaFeaturesList } from './BetaFeaturesList';

/**
 * Раздел «Beta функции»: перечень бета-функций системы с переключателем состояния у каждой.
 * Функции здесь только включаются и выключаются — состав перечня ведёт система.
 */
export const BetaFeaturesPage: FC = () => {
  const { t } = useTranslation('betaFeatures');
  const { data, isLoading } = useBetaFeatures();
  const { mutate: toggleFeature, isPending, variables } = useToggleBetaFeature();

  const handleToggle = (code: string, isEnabled: boolean) => toggleFeature({ code, isEnabled });

  return (
    <PageContainer className="flex flex-col gap-6">
      <h1 className="text-2xl font-bold">{t('pageTitle')}</h1>
      <AwaitContainer isLoading={isLoading}>
        <BetaFeaturesList
          features={data?.features ?? []}
          pendingCode={isPending ? (variables?.code ?? null) : null}
          onToggle={handleToggle}
        />
      </AwaitContainer>
    </PageContainer>
  );
};
